module.exports = __webpack_public_path__ + "img/shareLinkBlue.6388b09c.svg";